import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Box, Collapse, Drawer, List, ListItem, ListItemButton, ListItemIcon, Typography } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';

const HiddenNavbar = ({
    isMenuOpen,
    handleSetIsMenuOpen,
    hiddenNavbarItems,
    isCollapsedListOpen,
    handleSetIsCollapsedListOpen,
    collapsedListItems,
    userRole,
    anchor
}) => {
    return (
        <Drawer
            anchor={anchor}
            open={isMenuOpen}
            onClick={handleSetIsMenuOpen}
            sx={{
                display: {
                    xs: "block",
                    md: "none"
                },
                zIndex: 2000
            }}
        >
            <List
                sx={{
                    width: (anchor === "left" || anchor === "right") ? "250px" : "100%",
                    height: (anchor === "left" || anchor === "right") ? "100vh" : "auto",
                    overflow: "auto"
                }}
                onClick={(ev) => ev.stopPropagation()}
            >
                {hiddenNavbarItems.map((item, index) => {
                    return item.roles.includes(userRole.id) ? (
                        <ListItem disablePadding key={`${Math.random()}_${index}`}
                            className="my-2">
                            <Link to={item.to} className="w-full">
                                <ListItemButton sx={{ display: "flex", width: "100%" }}>
                                    <ListItemIcon sx={{ minWidth: "unset", ml: 1 }}>
                                        {item.icon}
                                    </ListItemIcon>
                                    <Typography>{item.text}</Typography>
                                </ListItemButton>
                            </Link>
                        </ListItem>
                    ) : null
                })}
                <ListItem disablePadding>
                    <ListItemButton sx={{ display: "flex", justifyContent: "space-between", width: "100%" }}
                        onClick={handleSetIsCollapsedListOpen}>
                        <Box sx={{ display: "flex" }}>
                            <ListItemIcon sx={{ minWidth: "unset", ml: 1 }}>
                                <AccountCircleIcon />
                            </ListItemIcon>
                            <Typography>حساب</Typography>
                        </Box>
                        <ListItemIcon sx={{ minWidth: "unset" }}>
                            {isCollapsedListOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                        </ListItemIcon>
                    </ListItemButton>
                </ListItem>
                <Collapse in={isCollapsedListOpen} timeout="auto" unmountOnExit>
                    <List>
                        {collapsedListItems.map((item, index) => (
                            <ListItem disablePadding key={`${Math.random()}_${index}`}
                                className="mb-1">
                                <Link to={item.to} className="w-full">
                                    <ListItemButton sx={{ display: "flex", width: "100%", px: "2rem" }}>
                                        <ListItemIcon sx={{ minWidth: "unset", ml: 1 }}>
                                            {item.icon}
                                        </ListItemIcon>
                                        <Typography>{item.text}</Typography>
                                    </ListItemButton>
                                </Link>
                            </ListItem>
                        ))}
                    </List>
                </Collapse>
            </List>
        </Drawer>
    );
}

export default HiddenNavbar;
